import React from 'react';
import classnames from 'classnames';

const Title: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, className }) => {
	return <div className={classnames('title', className)}>{children}</div>;
};

export default Title;
